import { CALL_API } from '../middleware/ApiMiddleware';
import { CREATE_SUBMISSION_FAILURE, CREATE_SUBMISSION_REQUEST, CREATE_SUBMISSION_SUCCESS } from './crm';

export const AC_LOOKUP_REQUEST = 'AC_LOOKUP_REQUEST';
export const AC_LOOKUP_SUCCESS = 'AC_LOOKUP_SUCCESS';
export const AC_LOOKUP_FAILURE = 'AC_LOOKUP_FAILURE';

export const AC_LOOKUP_BY_ID_REQUEST = 'AC_LOOKUP_BY_ID_REQUEST';
export const AC_LOOKUP_BY_ID_SUCCESS = 'AC_LOOKUP_BY_ID_SUCCESS';
export const AC_LOOKUP_BY_ID_FAILURE = 'AC_LOOKUP_BY_ID_FAILURE';

export const AC_RESET = 'AC_RESET';

/**
 * Phone lookup that creates one server-side lookup event.
 * hideDefaultAlert keeps the global toast from firing on the legitimate
 * disabled (404) state, which we render as a not-found page instead.
 * hideLoadingWidget: the component drives its own LOADING view, and the
 * middleware's hideDefaultAlert error path dispatches neither ERROR nor
 * FETCHING_COMPLETE — so leaving the global widget on would hang forever.
 */
export const lookupActionCenterContact = (phoneNumber: string) => ({
  [CALL_API]: {
    endpoint: 'agencies/action-center/lookup',
    method: 'get',
    params: { phoneNumber },
    authenticated: true,
    hideDefaultAlert: true,
    hideLoadingWidget: true,
    types: [AC_LOOKUP_REQUEST, AC_LOOKUP_SUCCESS, AC_LOOKUP_FAILURE],
  },
});

/**
 * Retrieve an existing lookup by id. Does not create a new event, so a
 * refresh on ?lookup_id= re-renders the same result without re-logging.
 */
export const getActionCenterLookupById = (lookupId: number) => ({
  [CALL_API]: {
    endpoint: `agencies/action-center/lookups/${lookupId}`,
    method: 'get',
    authenticated: true,
    hideDefaultAlert: true,
    hideLoadingWidget: true,
    types: [AC_LOOKUP_BY_ID_REQUEST, AC_LOOKUP_BY_ID_SUCCESS, AC_LOOKUP_BY_ID_FAILURE],
  },
});

export const resetActionCenter = () => ({
  type: AC_RESET,
});

export const createActionCenterLookupSubmission = (
  lookupId: number,
  submissionRequest: ICRMCreateSubmissionRequest
) => ({
  [CALL_API]: {
    endpoint: `agencies/action-center/lookups/${lookupId}/crm-issues`,
    method: 'post',
    body: submissionRequest,
    authenticated: true,
    types: [CREATE_SUBMISSION_REQUEST, CREATE_SUBMISSION_SUCCESS, CREATE_SUBMISSION_FAILURE],
  },
});
